/**
 * Real-Time Pakistan City Selection for Shopify Horizon Theme
 * Automatically syncs with Cart Drawer, AJAX updates & Checkout
 */
(function () {
  'use strict';

  const DEFAULT_CITIES = [
    "Karachi", "Lahore", "Islamabad", "Rawalpindi", "Faisalabad", "Gujranwala", "Multan", "Sialkot",
    "Bahawalpur", "Sargodha", "Gujrat", "Sheikhupura", "Sahiwal", "Jhelum", "Rahim Yar Khan",
    "Dera Ghazi Khan", "Kasur", "Okara", "Jhang", "Khanewal", "Vehari", "Burewala", "Chiniot",
    "Toba Tek Singh", "Kamalia", "Gojra", "Samundri", "Jaranwala", "Daska", "Wazirabad", "Hafizabad",
    "Mandi Bahauddin", "Kharian", "Lalamusa", "Chakwal", "Attock", "Taxila", "Wah Cantt", "Gujar Khan",
    "Murree", "Narowal", "Shakargarh", "Pakpattan", "Arifwala", "Chichawatni", "Mian Channu",
    "Lodhran", "Kabirwala", "Shujabad", "Muzaffargarh", "Kot Addu", "Layyah", "Rajanpur", "Taunsa Sharif",
    "Haroonabad", "Chishtian", "Yazman", "Ahmedpur East", "Khanpur", "Liaquatpur", "Hyderabad",
    "Sukkur", "Larkana", "Nawabshah", "Mirpur Khas", "Jacobabad", "Shikarpur", "Khairpur", "Dadu",
    "Ghotki", "Tando Adam", "Tando Allahyar", "Tando Muhammad Khan", "Badin", "Thatta", "Matiari",
    "Moro", "Naushahro Feroze", "Sanghar", "Shahdadkot", "Kandhkot", "Kashmore", "Umerkot", "Samaro",
    "Ratodero", "Peshawar", "Abbottabad", "Mardan", "Mingora", "Swat", "Nowshera", "Mansehra",
    "Kohat", "Bannu", "Dera Ismail Khan", "Charsadda", "Swabi", "Haripur", "Hangu", "Karak",
    "Batkhela", "Dir", "Timergara", "Chitral", "Takht Bhai", "Risalpur", "Topi", "Quetta", "Gwadar",
    "Turbat", "Khuzdar", "Hub", "Sibi", "Chaman", "Loralai", "Zhob", "Mastung", "Kalat",
    "Dera Murad Jamali", "Dera Allah Yar", "Nushki", "Muzaffarabad", "Mirpur", "Rawalakot", "Kotli",
    "Bhimber", "Bagh", "Hattian Bala", "Gilgit", "Skardu", "Hunza", "Chilas", "Ghizer"
  ];

  function getStoredCity() {
    try {
      return sessionStorage.getItem('pk_delivery_city') || localStorage.getItem('pk_delivery_city') || '';
    } catch (e) {
      return '';
    }
  }

  function setStoredCity(city) {
    try {
      if (city) {
        sessionStorage.setItem('pk_delivery_city', city);
        localStorage.setItem('pk_delivery_city', city);
      }
    } catch (e) {}
  }

  function getCityList(container) {
    if (container && container.dataset.cities) {
      const parsed = container.dataset.cities.split(',').map(c => c.trim()).filter(Boolean);
      if (parsed.length > 0) return parsed;
    }
    return DEFAULT_CITIES;
  }

  // Populate or Sync City Inputs in DOM
  function syncAllCityInputs() {
    const stored = getStoredCity();
    const containers = document.querySelectorAll('.pk-city-container');

    containers.forEach(container => {
      const input = container.querySelector('.pk-city-input');
      const listEl = container.querySelector('.pk-city-dropdown-list');

      // Populate dropdown list if empty
      if (listEl && listEl.children.length === 0) {
        const cities = getCityList(container);
        const frag = document.createDocumentFragment();
        cities.forEach(city => {
          const item = document.createElement('div');
          item.className = 'pk-city-option';
          item.setAttribute('data-city', city);
          item.setAttribute('role', 'option');
          item.textContent = city;
          frag.appendChild(item);
        });
        listEl.appendChild(frag);
      }

      // Populate input with stored city if empty
      if (input && stored && !input.value) {
        input.value = stored;
      }
    });
  }

  // Live Filter dropdown
  function filterDropdown(container, query) {
    const listEl = container.querySelector('.pk-city-dropdown-list');
    if (!listEl) return;

    const q = (query || '').toLowerCase().trim();
    const options = listEl.querySelectorAll('.pk-city-option:not(.pk-no-result)');
    let matches = 0;

    options.forEach(opt => {
      const cityName = (opt.getAttribute('data-city') || opt.textContent).toLowerCase();
      if (!q || cityName.includes(q)) {
        opt.style.display = 'block';
        matches++;
      } else {
        opt.style.display = 'none';
      }
    });

    let noRes = listEl.querySelector('.pk-no-result');
    if (matches === 0) {
      if (!noRes) {
        noRes = document.createElement('div');
        noRes.className = 'pk-no-result';
        noRes.textContent = 'No matching city found';
        listEl.appendChild(noRes);
      }
      noRes.style.display = 'block';
    } else if (noRes) {
      noRes.style.display = 'none';
    }

    listEl.classList.add('is-open');
  }

  // Update Shopify Cart Attributes via AJAX
  async function updateCartAttributes(city) {
    if (!city) return;
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Delivery City': city,
            'City': city,
            'delivery_city': city
          },
          note: `Delivery Destination: ${city}`
        })
      });
    } catch (e) {
      console.warn('[Cart City Selection] Failed to update cart attributes:', e);
    }
  }

  // Document Event Delegation for Input
  document.addEventListener('input', function (e) {
    const input = e.target.closest('.pk-city-input');
    if (!input) return;

    const container = input.closest('.pk-city-container');
    if (!container) return;

    const errorEl = container.querySelector('.pk-city-error');
    if (errorEl) errorEl.classList.remove('is-visible');
    input.classList.remove('has-error');

    filterDropdown(container, input.value);
  });

  // Document Event Delegation for Focusin / Click on Input
  document.addEventListener('focusin', function (e) {
    const input = e.target.closest('.pk-city-input');
    if (!input) return;

    const container = input.closest('.pk-city-container');
    if (!container) return;

    syncAllCityInputs();
    filterDropdown(container, input.value);
  });

  document.addEventListener('click', function (e) {
    // 1. Click on City Option in Dropdown
    const option = e.target.closest('.pk-city-option');
    if (option && !option.classList.contains('pk-no-result')) {
      const container = option.closest('.pk-city-container');
      if (container) {
        const input = container.querySelector('.pk-city-input');
        const listEl = container.querySelector('.pk-city-dropdown-list');
        const errorEl = container.querySelector('.pk-city-error');
        const cityName = option.getAttribute('data-city') || option.textContent.trim();

        if (input) {
          input.value = cityName;
          input.classList.remove('has-error');
        }
        // Update hidden inputs for full Shopify cart form compatibility
        container.querySelectorAll('.pk-city-hidden-attr, .pk-city-hidden-attr-key').forEach(h => {
          h.value = cityName;
        });
        if (listEl) {
          listEl.classList.remove('is-open');
        }
        if (errorEl) {
          errorEl.classList.remove('is-visible');
        }

        setStoredCity(cityName);
        updateCartAttributes(cityName);
      }
      return;
    }

    // 2. Click on Clear Button
    const clearBtn = e.target.closest('.pk-city-clear');
    if (clearBtn) {
      const container = clearBtn.closest('.pk-city-container');
      if (container) {
        const input = container.querySelector('.pk-city-input');
        if (input) {
          input.value = '';
          input.focus();
          filterDropdown(container, '');
        }
      }
      return;
    }

    // 3. Click outside city container closes dropdown
    if (!e.target.closest('.pk-city-container')) {
      document.querySelectorAll('.pk-city-dropdown-list.is-open').forEach(el => {
        el.classList.remove('is-open');
      });
    }
  });

  // Intercept Checkout Buttons to Guarantee City is Selected
  async function handleCheckoutAttempt(e) {
    const containers = document.querySelectorAll('.pk-city-container');
    if (containers.length === 0) return; // If feature is disabled, allow normal checkout

    // Find active / visible container (e.g., in Cart Drawer or on Cart page)
    let activeContainer = null;
    for (let i = 0; i < containers.length; i++) {
      if (containers[i].offsetParent !== null) {
        activeContainer = containers[i];
        break;
      }
    }
    if (!activeContainer) activeContainer = containers[0];

    const input = activeContainer.querySelector('.pk-city-input');
    const errorEl = activeContainer.querySelector('.pk-city-error');
    const cities = getCityList(activeContainer);

    const val = input ? input.value.trim() : '';
    const match = cities.find(c => c.toLowerCase() === val.toLowerCase());

    if (!match) {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (input) {
        input.classList.add('has-error');
        input.focus();
        filterDropdown(activeContainer, input.value);
      }
      if (errorEl) {
        errorEl.classList.add('is-visible');
      }

      // Scroll into view if needed
      activeContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }

    // Valid city selected! Sync with cart before continuing
    setStoredCity(match);
    
    // Prevent default checkout submission so we can guarantee cart attributes are saved and prefilled in checkout
    e.preventDefault();
    e.stopImmediatePropagation();

    // Disable button temporarily to prevent double submission
    const targetBtn = e.target.closest('button, a') || activeContainer.closest('form')?.querySelector('button[name="checkout"]');
    if (targetBtn) {
      targetBtn.disabled = true;
      targetBtn.classList.add('loading');
    }

    try {
      await updateCartAttributes(match);
    } catch (err) {
      console.warn(err);
    }

    // Build Shopify checkout prefill URL with standard Shopify parameters
    const checkoutUrl = `/checkout?checkout[shipping_address][city]=${encodeURIComponent(match)}&checkout[billing_address][city]=${encodeURIComponent(match)}&checkout[attributes][Delivery%20City]=${encodeURIComponent(match)}&checkout[attributes][City]=${encodeURIComponent(match)}&step=contact_information`;
    
    window.location.href = checkoutUrl;
    return false;
  }

  // Attach to Checkout Actions (capturing phase for 100% intercept reliability)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('button[name="checkout"], #checkout, .cart__checkout-button, [data-testid="checkout-button"], a[href*="/checkout"]');
    if (btn) {
      handleCheckoutAttempt(e);
    }
  }, true);

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (form && (form.action.includes('/checkout') || form.action.includes('/cart'))) {
      const submitter = e.submitter;
      if (submitter && submitter.name === 'checkout') {
        handleCheckoutAttempt(e);
      }
    }
  }, true);

  // MutationObserver & Lifecycle to re-sync whenever Cart Drawer updates or morphs
  const observer = new MutationObserver(function () {
    syncAllCityInputs();
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  // Initial synchronization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllCityInputs);
  } else {
    syncAllCityInputs();
  }

})();
